var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36919",
    "data-name": "Group 36919",
    transform: "translate(7639.037 -11783.963)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light-Outline_Delete",
    "data-name": "Iconly/Light-Outline/Delete",
    transform: "translate(-7637.026 11784.973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Delete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M21.285,8.73a.976.976,0,0,1,.894,1.05c-.008.088-.712,8.806-1.117,12.463a3.866,3.866,0,0,1-4.014,3.692c-1.732.03-3.4.047-5.035.047-1.76,0-3.476-.019-5.174-.055a3.854,3.854,0,0,1-3.921-3.675C2.508,18.562,1.808,9.866,1.8,9.779a.973.973,0,0,1,.892-1.05,1,1,0,0,1,1.05.892c0,.056.29,3.608.6,7.121l.063.7c.157,1.746.316,3.424.446,4.593a1.912,1.912,0,0,0,2.024,1.941c3.248.069,6.562.073,10.134.008a1.943,1.943,0,0,0,2.112-1.958c.4-3.63,1.1-12.318,1.112-12.406A1,1,0,0,1,21.285,8.73ZM14.738,0a2.641,2.641,0,0,1,2.549,1.956l.33,1.638a1.168,1.168,0,0,0,1.124.938H23a.974.974,0,1,1,0,1.949H.974a.974.974,0,1,1,0-1.949H5.237l.131-.008a1.172,1.172,0,0,0,.994-.928l.316-1.58A2.655,2.655,0,0,1,9.24,0Zm0,1.949H9.24a.687.687,0,0,0-.665.509l-.3,1.52a3.091,3.091,0,0,1-.166.555h7.767a3.1,3.1,0,0,1-.167-.555L15.391,2.4A.681.681,0,0,0,14.738,1.949Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1169",
    "data-name": "Rectangle 1169",
    width: 28,
    height: 28,
    transform: "translate(-7639.037 11783.963)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.b3c357d2a5a0fc6f345fe3da7a72c554.svg";
export { ForwardRef as ReactComponent };